import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@clerk/clerk-react';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers';
import { GET_LIVE_CONTEXT_STATE_QUERY_KEY } from '@/state/queries/player/use-get-live-context-state';
import {
  GET_FLOW_MEDIA_AGENT_QUERY_KEY,
  type FlowMediaAgentState,
} from '@/state/queries/playout/use-get-flow-media-agent';

export function usePatchFlowMediaAgentMutation(flowId?: string) {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (enabled: boolean) => {
      const token = await getToken();
      const url = `${import.meta.env.VITE_API_URL}/flows/${flowId}/playout/media-agent`;
      return sendJSONRequest({
        url,
        method: METHOD.PATCH,
        body: { enabled },
        token: token ?? '',
      }) as Promise<FlowMediaAgentState>;
    },
    onSuccess: (state) => {
      queryClient.setQueryData([GET_FLOW_MEDIA_AGENT_QUERY_KEY, flowId], state);
      void queryClient.invalidateQueries({ queryKey: [GET_LIVE_CONTEXT_STATE_QUERY_KEY] });
    },
  });
}
